import React from "react";
import { Dialog, DialogContent, Stack, SvgIcon } from "@mui/material";
// import { Transition } from "../Transition/Transition";

import { ReactComponent as PlayIcon } from "../../../assets/icons/icon-play.svg";

import "./PauseOverlay.scss";

const PauseOverlay = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      className="pause-overlay-dialog"
      sx={{
        "& .MuiDialog-paper": {
          backgroundColor: "transparent",
          backdropFilter: "blur(24px)",
          width: "1280px",
          height: "860px",
        },
        "& .MuiBackdrop-root": {
          backgroundColor: "none", // Change backdrop color
        },
      }}
      maxWidth={false}
      keepMounted
      disablePortal
    >
      <Stack className="dotted-background">
        <DialogContent>
          <div className="pause-overlay-container">
            <div className="pause-button" onClick={onClose}>
              <SvgIcon component={PlayIcon} inheritViewBox />
              <span className="pause-label">Play</span>
            </div>
            <div className="pause-text-box">
              <p>
                Your game is paused and progress saved. Press play to resume.
              </p>
            </div>
          </div>
        </DialogContent>
      </Stack>
    </Dialog>
  );
};

export default PauseOverlay;
